import { useEffect } from 'react'
import BottomSheetContent from '../../../components/BottomSheetComponents/BottomSheetContent'
import { One } from '../../../icons/rebalance/One'
import { Two } from '../../../icons/rebalance/Two'
import { Three } from '../../../icons/rebalance/Three'
import { TaxHarvestingBottomSheetName, trackTaxHarvestingBottomSheetLoaded } from '../tracking/taxHarvestingTracking'

type HowGainsHarvestingWorksSheetProps = {
  onDismiss: () => void
  /** From plan summary: possible tax save (e.g. ₹15,625); shown in point 1 when provided */
  saveTax?: number
}

export function HowGainsHarvestingWorksSheet({ onDismiss, saveTax }: HowGainsHarvestingWorksSheetProps) {
  useEffect(() => {
    trackTaxHarvestingBottomSheetLoaded(TaxHarvestingBottomSheetName.HowGainsHarvestingWorks)
  }, [])

  const point1Copy = '⁠Up to ₹1.25L equity long-term capital gains are tax-exempted every financial year.'

  return (
    <BottomSheetContent heading="How does booking gains save future tax?" onDismiss={onDismiss}>
      <div className="pt-2 pb-4 flex flex-col gap-4 text-[14px] text-[#3D3D3D]">
        <div className="flex items-start gap-3">
          <div className="mt-[2px] flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#D0D5DD] text-[12px] text-[#3D3D3D]">
            <One />
          </div>
          <p className="leading-[1.5] text-[#3D3D3D]">
            {point1Copy}
          </p>
        </div>
        <div className="flex items-start gap-3">
          <div className="mt-[2px] flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#D0D5DD] text-[12px] text-[#3D3D3D]">
            <Two />
          </div>
          <p className="leading-[1.5] text-[#3D3D3D]">
            Gains above this are taxed at 12.5%.
          </p>
        </div>
        <div className="flex items-start gap-3">
          <div className="mt-[2px] flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[#D0D5DD] text-[12px] text-[#3D3D3D]">
            <Three />
          </div>
          <p className="leading-[1.5] text-[#3D3D3D]">
            Tax will be levied on your LTCG, whether you withdraw now or years later. Using this exemption every year reduces the tax you&apos;ll have to pay in future.
          </p>
        </div>
        <div className="pt-1 text-[#3D3D3D]">
          By booking ₹1.25 lakh of gains you&apos;re utilising your exemption for this FY, and avoid 12.5% tax on it later, saving up to ₹15,625 in future tax.
        </div>
      </div>
    </BottomSheetContent>
  )
}
